"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Props related to HTML <a> anchor link attributes.
const targetValues = ['_self', '_blank', '_parent', '_top'];
var _default = exports.default = {
  types: {
    // React Native Web >= 0.15.0 supports hrefAttrs prop with only these properties
    // and passes them to <a> if an element has a href prop or accessibilityRole "link"
    download: _propTypes.default.string,
    rel: _propTypes.default.string,
    target: _propTypes.default.oneOf(targetValues)
  },
  /**
   * Takes a props object, bundles any hrefAttrs props present into one object
   * and returns that keyed as `hrefAttrs` and non-hrefAttrs props keyed as `rest`
   */
  bundle: _ref => {
    let {
      download,
      rel,
      target,
      ...rest
    } = _ref;
    return {
      hrefAttrs: {
        download,
        rel,
        target
      },
      rest
    };
  }
};